import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(['@/pages/login'], resolve),
    },
    {
      path: '/dashboard',
      name: 'dashBoard',
      meta: {
        menu: '/dashboard'
      },
      component: resolve => require(['@/pages/dashBoard'], resolve)
    },
    {
      path: '/applyList',
      name: 'ApplyList',
      meta: {
        menu: '/applyList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/apply'], resolve)
    },
    // 新投保单----产品信息
    {
      path: '/productInfo',
      name: 'ProductInfo',
      meta: {
        menu: '/applyList'
      },
      component: resolve => require(['@/pages/apply/productInfo'], resolve)
    },
    // 新投保单----被保人清单
    {
      path: '/insureList',
      name: 'InsureList',
      meta: {
        menu: '/applyList'
      },
      component: resolve => require(['@/pages/apply/insureList'], resolve)
    },
    // 新投保单----健康告知及受益人
    {
      path: '/favorer',
      name: 'Favorer',
      meta: {
        menu: '/applyList'
      },
      component: resolve => require(['@/pages/apply/favorer'], resolve)
    },
    // 新投保单----险种确认
    {
      path: '/typeConfirm',
      name: 'typeConfirm',
      meta: {
        menu: '/applyList'
      },
      component: resolve => require(['@/pages/apply/typeConfirm'], resolve)
    },
    // 新投保单----基本信息
    {
      path: '/basicInfo',
      name: 'basicInfo',
      meta: {
        menu: '/applyList'
      },
      component: resolve => require(['@/pages/apply/basicInfo'], resolve)
    },
    // 新投保单----投保资料上传
    {
      path: '/imageUpload',
      name: 'imageUpload',
      meta: {
        menu: '/applyList'
      },
      component: resolve => require(['@/pages/apply/imageUpload'], resolve)
    },
    // 投保单，查看详情
    {
      path: '/contract/:id',
      name: 'contract',
      meta: {
        menu: '/applyList'
      },
      component: resolve => require(['@/pages/apply/contract'], resolve)
    },
    // 支付列表
    {
      path: '/toPayList',
      name: 'ToPayList',
      meta: {
        menu: '/toPayList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/pay'], resolve)
    },
    // 支付详情
    {
      path: '/toPayDetail/:id',
      name: 'ToPayDetail',
      meta: {
        menu: '/toPayList'
      },
      component: resolve => require(['@/pages/pay/detail'], resolve)
    },
    // 保单查询列表
    {
      path: '/policyList',
      name: 'PolicyList',
      meta: {
        menu: '/policyList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/policy'], resolve)
    },
    // 保单详情页
    {
      path: '/groupPolicyDetails/:policyId',
      name: 'GroupPolicyDetails',
      meta: {
        menu: '/policyList'
      },
      component: resolve => require(['@/pages/policy/detail'], resolve)
    },
    // 批单列表
    {
      path: '/groupChangePolicy',
      name: 'groupChangePolicy',
      meta: {
        menu: '/groupChangePolicy',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/changPolicy'], resolve)
    },
    // 批单详情
    {
      path: '/groupChangePolicyDetails',
      name: 'groupChangePolicyDetails',
      meta: {
        menu: '/groupChangePolicy'
      },
      component: resolve => require(['@/pages/changPolicy/detail'], resolve)
    },
    // 批单录单页面
    {
      path: '/insuredOperation/:step',
      name: 'insuredOperation',
      meta: {
        menu: '/groupChangePolicy'
      },
      component: resolve => require(['@/pages/changPolicy/insuredOperation'], resolve)
    },
    // 续保
    {
      path: '/renewalList',
      name: 'renewalList',
      meta: {
        menu: '/renewalList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/renewal'], resolve)
    },
    // 续保流程
    {
      path: '/renewalStep/:step',
      name: 'renewalStep',
      meta: {
        menu: '/renewalList'
      },
      component: resolve => require(['@/pages/renewal/step'], resolve)
    },
    // 续保详情
    {
      path: '/renewalDetail',
      name: 'renewalDetail',
      meta: {
        menu: '/renewalList'
      },
      component: resolve => require(['@/pages/renewal/detail'], resolve)
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js